import { gql } from '@apollo/client';

export const GET_PRODUCT_SALES_FOR_PRODUCTS = gql(/* GraphQL */ `
    query GetProductSalesForProducts(
        $productIds: [String!]!
        $startDate: DateTime!
        $endDate: DateTime!
    ) {
        getProductSalesForProducts(
            productIds: $productIds
            startDate: $startDate
            endDate: $endDate
        ) {
            productId
            totalQuantity
        }
    }
`);

export const GET_SCOPED_PRODUCT_SALES_FOR_PRODUCTS = gql(/* GraphQL */ `
    query GetScopedProductSalesForProducts(
        $productIds: [String!]!
        $startDate: DateTime!
        $endDate: DateTime!
        $scope: ProductSalesScopeInput
    ) {
        getScopedProductSalesForProducts(
            productIds: $productIds
            startDate: $startDate
            endDate: $endDate
            scope: $scope
        ) {
            items {
                productId
                totalQuantity
            }
            isWarming
            warmingProductIds
            storeCount
        }
    }
`);
